import * as React from 'react';
import type { Participant } from 'livekit-client';
import {
  useScreenShareAudioBorder,
  type ScreenShareAudioBorderOptions,
} from '@/hooks/use-screen-share-audio-border';
import { cn } from '@/lib/utils.ts';
import '@/styles/screen-share-audio-border.css';

export interface ScreenShareAudioBorderProps extends React.HTMLAttributes<HTMLDivElement> {
  participant: Participant;
  enabled?: boolean;
  silent?: boolean;
  options?: Omit<ScreenShareAudioBorderOptions, 'enabled' | 'silent'>;
}

export function ScreenShareAudioBorder({
  participant,
  enabled = true,
  silent = false,
  options,
  className,
  ...htmlProps
}: ScreenShareAudioBorderProps) {
  const borderRef = React.useRef<HTMLDivElement>(null);

  useScreenShareAudioBorder(participant, borderRef, {
    enabled,
    silent,
    ...options,
  });

  return (
    <div
      ref={borderRef}
      aria-hidden
      className={cn(
        'screen-share-audio-border pointer-events-none absolute inset-0 box-border z-20',
        className
      )}
      {...htmlProps}
    />
  );
}
